module.exports = __webpack_public_path__ + "img/bg-contact-us.6ad5f343.png";